import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class BrowserService {
    private platformId = inject(PLATFORM_ID);

    get isBrowser(): boolean {
        return isPlatformBrowser(this.platformId);
    }

    windowExists(): boolean {
        return this.isBrowser;
    }

    getWindow(): Window | null {
        return this.isBrowser ? window : null;
    }

    getDocument(): Document | null {
        return this.isBrowser ? document : null;
    }

    getSessionStorage(): Storage | null {
        return this.isBrowser ? sessionStorage : null;
    }
}
